import { makeStyles } from '@material-ui/core/styles';
import { LayoutDirection } from 'features/app/ts/LayoutDirection';

export const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none',
    position: 'static',
    backgroundColor: '#fafafa',
  },
  toolbar: {
    backgroundColor: theme.palette.background.paper,
    paddingTop: 30,
    paddingBottom: 30,
    paddingRight: 53,
    paddingLeft: 41,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    color: theme.palette.common.black,
  },
  headerItems: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxSizing: 'content-box',
  },
  menuIcon: {
    paddingBottom: 9,
    margin: ({ direction }: LayoutDirection) => direction === 'rtl' ? '0 0 0 38px' : '0 38px 0 0 ',
  },
}));
